// 校验手机号是否正确
export const isPhoneAvailable = (phone: string) => {
  const myReg = /^1\d{10}$/;
  return myReg.test(phone);
};

export default null;
